<template>
  <div class="bootstrap-wrapper">
    <div class="container">
      <div class="row hidden-row"></div>

      <div class="row">
        <div class="col-12 my-5">
          <h5>
            <unicon
              :name="'dumbbell'"
              :fill="secCol"
              style="margin-right: 8px;"
            />
            <span>Desafíos</span>
          </h5>
        </div>
      </div>

      <div class="row mb-5">
        <div class="col-12 ml-5 pl-5">
          <span class="subtitle text-dark">
            Catálago de Desafíos
          </span>
        </div>
      </div>
      <CarouselContainer @filter="filterChallenge" />

      <!-- <ChallengeSelect @change="getChallengesById" /> -->

      <div class="row mt-5">
        <div class="col-md-4">
          <CustomInput :icon="'fa fa-search'">
            <input
              type="text"
              slot="input"
              v-model="challenge.name"
              @change="setFields"
              placeholder="Buscar desafío"
            />
          </CustomInput>
        </div>
        <div class="col-md-4">
          <DropSelect v-bind="selectLevel" v-model="selectLevel.selected" />
        </div>
        <div class="col-md-4">
          <DropSelect v-bind="selectType" v-model="selectType.selected" />
        </div>
      </div>
      <div class="row">
        <template v-if="challenges.length">
          <template v-for="(challenge, i) in challenges">
            <!-- <ChallengeCard
            :key="i"
            :title="'Desafio ' + (i + 1)"
            :liked="Math.random() >= 0.5"
            :rating="Math.floor(Math.random() * 6)"
            :category="Math.floor(Math.random() * 10)"
            @openCard="openCard"
            @setLike="setLike"
          /> -->
            <ChallengeCard
              :key="i"
              @openCard="openCard(challenge)"
              :cardData="challenge"
              :img="categoryImg"
            />
          </template>
        </template>
        <!-- <div class="col-12 subtitle text-center" v-else>
          cargando desafíos...
        </div> -->
      </div>

      <div class="row" v-if="showSpinner">
        <div class="col-12 text-center">
          <Spinner />
        </div>
      </div>

      <Pagination
        :currentPage="currentPage"
        :totalPages="totalPages"
        :sizeList="sizeList"
        v-if="challenges.length"
        @setPage="setPage"
        @setSize="setSize"
      />

      <ChallengeDetailModal
        :challengeData="challengeData"
        v-if="showModal.challengeDetail"
        @close="showModal.challengeDetail = false"
      />

      <div class="row">
        <FooterComponent />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import CarouselContainer from "@/components/CarouselContainer";
import CustomInput from "@/components/CustomInput";
import ChallengeCard from "@/components/ChallengeCard";
import ChallengeDetailModal from "@/components/challenge/ModalChallenge";
import FooterComponent from "@/components/Footer";
// import ChallengeSelect from "@/components/challenge/ChallengeSelect";
import Pagination from "@/components/Pagination";
import Spinner from "@/components/Spinner";
import DropSelect from "@/components/DropSelect";

export default {
  name: "Challenges",
  components: {
    CarouselContainer,
    CustomInput,
    ChallengeCard,
    ChallengeDetailModal,
    FooterComponent,
    // ChallengeSelect,
    Pagination,
    Spinner,
    DropSelect,
  },
  data() {
    let { secCol } = this.$store.getters;

    return {
      secCol,
      showModal: {
        challengeDetail: false,
      },
      challenges: [],
      challengeData: null,
      currentPage: 0,
      totalPages: null,
      category: null,
      categoryImg: null,
      sizeList: 12,
      showSpinner: false,
      challenge: {
        name: null,
      },
      selectLevel: {
        id: "level",
        supTitle: "Nivel",
        placeholder: "Elige nivel",
        selected: "",
        icon: "graduation-hat",
        textKey: "value",
        valueKey: "id",
        options: [],
      },
      selectType: {
        id: "type",
        supTitle: "Tipo de texto",
        placeholder: "Elige tipo de texto",
        selected: "",
        icon: "swatchbook",
        textKey: "value",
        valueKey: "id",
        options: [],
      },
    };
  },
  computed: {
    ...mapState(["dataUrl", "teacherData"]),
  },
  watch: {
    "selectLevel.selected"() {
      this.setFields();
    },
    "selectType.selected"() {
      this.setFields();
    },
  },
  methods: {
    filterChallenge(category) {
      this.getChallengesById(category);
    },
    setPage(page) {
      this.currentPage = page;
      if (this.category) {
        this.getChallengesById(
          { id: this.category, nombre: this.categoryImg },
          "noReset"
        );
      } else {
        this.getChallenges("noReset");
      }
    },
    setSize(size) {
      this.sizeList = size;
      this.currentPage = 0;
      if (this.category) {
        this.getChallengesById(
          { id: this.category, nombre: this.categoryImg },
          "noReset"
        );
      } else {
        this.getChallenges("noReset");
      }
    },
    setFields() {
      if (!this.category) return;
      this.getChallengesById({ id: this.category, nombre: this.categoryImg });
    },
    openCard(data) {
      this.challengeData = data;
      this.showModal.challengeDetail = true;
    },
    async getChallengesById(val, type = null) {
      if (!val) {
        // this.getChallenges();
        return;
      }

      if (type != "noReset") {
        this.currentPage = 0;
        this.sizeList = 12;
      }

      let params = "";

      if (this.challenge.name) params += `&nombre=${this.challenge.name}`;
      if (!isNaN(this.selectLevel.selected))
        params += `&aplicaNivel=${this.selectLevel.selected}`;
      if (!isNaN(this.selectType.selected))
        params += `&tipo=${this.selectType.selected}`;

      let { id, nombre } = val;
      let apiUrl = `${this.dataUrl}/mdTest/findPageByCategoryIdAndParams?userId=${this.teacherData.id}&categoryId=${id}${params}&pageNumber=${this.currentPage}&pageSize=${this.sizeList}`;

      this.category = id;
      this.categoryImg = nombre;
      this.challenges = [];
      this.showSpinner = true;

      try {
        let { data } = await this.axios.get(apiUrl);

        this.challenges = data.content.content;
        this.totalPages = data.content.totalPages;
      } catch {
        this.$notify({
          title: ["Ocurrió un error"],
          type: "danger",
        });
        // this.getChallengesById(val);
      } finally {
        this.showSpinner = false;
      }
    },
    async getFilters() {
      let apiUrl = `${this.dataUrl}/mdTest/getFilterData`;

      try {
        let { data } = await this.axios.get(apiUrl);

        if (data.status.name.toLocaleLowerCase() == "ok") {
          this.selectLevel.options = data.content.gradeList;
          this.selectType.options = data.content.typeList;
        } else {
          this.$notify({
            title: ["Ocurrió un error"],
            type: "danger",
          });
        }
      } catch {
        this.$notify({
          title: ["Ocurrió un error"],
          type: "danger",
        });
      }
    },
  },
  mounted() {
    this.getFilters();
  },
};
</script>
